/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetpassworddesc2Inputs */

const zh_auth_resetpassworddesc2 = /** @type {(inputs: Auth_Resetpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的新密码。`)
};

const en_auth_resetpassworddesc2 = /** @type {(inputs: Auth_Resetpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your new password below.`)
};

const es_auth_resetpassworddesc2 = /** @type {(inputs: Auth_Resetpassworddesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu nueva contraseña a continuación.`)
};

/**
* | output |
* | --- |
* | "Enter your new password below." |
*
* @param {Auth_Resetpassworddesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetpassworddesc2 = /** @type {((inputs?: Auth_Resetpassworddesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetpassworddesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetpassworddesc2(inputs)
	if (locale === "en") return en_auth_resetpassworddesc2(inputs)
	return es_auth_resetpassworddesc2(inputs)
});
export { auth_resetpassworddesc2 as "auth_resetPasswordDesc" }